<template>
  <div class="help-list">
    <mt-header fixed :title="titleText" class="title1">
      <mt-button slot="left" icon="back" @click="backClickHandler">返回</mt-button>
    </mt-header>
    <div>
      <div class="list-content">
        <mt-cell icon="search" v-for="(item, index) in currentHelpText" :key="index" :title="item.title" :to="{ path: '/helpdetail', query: { id: item.id } }" is-link />
        <mt-cell :title="serviceMobile.title" :value="serviceMobile.mobile" />
      </div>
    </div>
  </div>
</template>

<script>
/* global
    PUBLIC_PRODUCT,
    PUBLIC_HELP_CXYF,
    PUBLIC_HELP_CXYF_MOBILE
*/

export default {
  name: 'HelpList',
  props: ['titleText'],
  data() {
    return {
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
      helpText: PUBLIC_HELP_CXYF,
      serviceMobile: PUBLIC_HELP_CXYF_MOBILE,
    };
  },
  computed: {
    currentHelpText() {
      return this.helpText.filter(item => item.product.indexOf(this.product) > -1);
    },
  },
  methods: {
    backClickHandler() {
      window.location.href = 'protocol://android';
    },
  },
};
</script>
